module.exports = __webpack_public_path__ + "img/goteborgs-posten.8fd1b306.png";